(() => {
  const root = document.querySelector('.seednary-product-page');
  if (!root) return;

  const rootPath = () => (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  const cartAddUrl = () => `${rootPath()}/cart/add.js`;
  const cartUrl = () => `${rootPath()}/cart.js`;
  const drawer = () => document.querySelector('[data-seednary-cart-drawer]');

  const openCartDrawer = () => {
    const seednaryDrawer = drawer();
    if (seednaryDrawer) {
      document.dispatchEvent(new CustomEvent('seednary:cart:open', { bubbles: true }));
      return true;
    }

    const themeDrawer = document.querySelector('cart-drawer-component, cart-drawer, #CartDrawer, [data-cart-drawer]');
    if (themeDrawer) {
      if (typeof themeDrawer.open === 'function') {
        themeDrawer.open();
        return true;
      }
      if (typeof themeDrawer.showDialog === 'function') {
        themeDrawer.showDialog();
        return true;
      }
      const dialog = themeDrawer.querySelector?.('dialog');
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
        return true;
      }
    }

    const trigger = document.querySelector(
      'cart-icon a, .header-actions__cart-icon a, .header-actions__cart-icon, [data-testid="cart-drawer-trigger"], [aria-controls="CartDrawer"], [data-cart-drawer-toggle]'
    );
    if (trigger && typeof trigger.click === 'function') {
      trigger.click();
      return true;
    }
    return false;
  };

  const replaceSeednaryDrawer = (sections) => {
    const current = drawer();
    const sectionId = current?.dataset.seednaryCartSectionId;
    const html = sectionId ? sections?.[sectionId] : null;
    if (!html || !current) return false;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-seednary-cart-drawer]');
    if (!fresh) return false;

    current.replaceWith(fresh);
    fresh.classList.add('is-open');
    fresh.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('seednary-cart-open');
    return true;
  };

  const refreshSeednaryDrawer = async () => {
    const current = drawer();
    const sectionId = current?.dataset.seednaryCartSectionId;
    if (!sectionId) return false;

    const separator = window.location.search ? '&' : '?';
    const response = await fetch(`${window.location.pathname}${window.location.search}${separator}sections=${sectionId}`, {
      headers: { Accept: 'application/json' },
    });
    const sections = await response.json().catch(() => ({}));
    return replaceSeednaryDrawer(sections);
  };

  const updateCartCount = (cart) => {
    const count = cart?.item_count ?? 0;
    document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble__text-count, .cart-count-bubble span:first-child').forEach((node) => {
      node.textContent = count;
      node.classList.toggle('hidden', count === 0);
    });
  };

  const dispatchCartEvents = (cart, sourceId, itemCount, sections) => {
    const detail = {
      resource: cart,
      sourceId,
      data: {
        source: 'seednary-product-form',
        itemCount,
        sections,
      },
      sections,
    };
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
  };

  const selectedVariantInput = () =>
    root.querySelector('.variant-option__button-label input:checked[data-seednary-price]') ||
    root.querySelector('.variant-option__select option:checked[data-seednary-price]') ||
    root.querySelector('[data-seednary-price]');

  const updateAddButtonPrice = () => {
    const input = selectedVariantInput();
    const price = input?.dataset?.seednaryPrice;
    if (!price) return;

    const buttonText =
      root.querySelector('.add-to-cart-text__content') ||
      root.querySelector('.add-to-cart-button span') ||
      root.querySelector('.add-to-cart-button');
    if (!buttonText) return;

    let priceNode = buttonText.querySelector('.seednary-add-price');
    if (!priceNode) {
      priceNode = document.createElement('span');
      priceNode.className = 'seednary-add-price';
      buttonText.appendChild(document.createTextNode(' - '));
      buttonText.appendChild(priceNode);
    }
    priceNode.textContent = price;
  };

  const getProductAddForm = (target) => {
    const form = target?.closest?.('form[action*="/cart/add"]');
    if (!form || !root.contains(form)) return null;
    if (form.matches('[data-seednary-cart-recommendation-form], [data-seednary-discount-form]')) return null;
    return form;
  };

  const getSubmitButton = (form, submitter) =>
    submitter?.matches?.('button, [type="submit"]') ? submitter : form.querySelector('[type="submit"], .add-to-cart-button, button');

  const ajaxAddToCart = async (form, submitter) => {
    const button = getSubmitButton(form, submitter);
    if (button?.disabled || button?.getAttribute('aria-busy') === 'true') return;

    button?.setAttribute('aria-busy', 'true');
    button?.classList.add('is-loading');
    if (button) button.disabled = true;

    try {
      const formData = new FormData(form);
      const sectionId = drawer()?.dataset.seednaryCartSectionId;
      if (sectionId) {
        formData.set('sections', sectionId);
        formData.set('sections_url', window.location.pathname);
      }

      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const added = await response.json().catch(() => ({}));
      if (!response.ok || added.status) throw new Error(added.description || added.message || 'Add to cart failed');

      const cart = await fetch(cartUrl(), { headers: { Accept: 'application/json' } }).then((res) => res.json());
      updateCartCount(cart);

      let drawerUpdated = replaceSeednaryDrawer(added.sections);
      if (!drawerUpdated) {
        openCartDrawer();
        drawerUpdated = await refreshSeednaryDrawer();
      }

      dispatchCartEvents(cart, String(formData.get('id') || ''), Number(formData.get('quantity') || 1), added.sections);

      window.setTimeout(async () => {
        if (drawer()?.classList.contains('is-open')) {
          if (!drawerUpdated) await refreshSeednaryDrawer();
          document.dispatchEvent(new CustomEvent('seednary:cart:open', { bubbles: true }));
        }
      }, 120);
    } catch (error) {
      console.error('[seednary product] Add to cart failed', error);
      document.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { data: error } }));
    } finally {
      button?.removeAttribute('aria-busy');
      button?.classList.remove('is-loading');
      if (button) button.disabled = false;
    }
  };

  root.addEventListener('submit', (event) => {
    const form = getProductAddForm(event.target);
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();
    ajaxAddToCart(form, event.submitter);
  }, true);

  root.addEventListener('click', (event) => {
    const button = event.target.closest?.('[type="submit"], .add-to-cart-button');
    if (!button) return;
    const form = getProductAddForm(button);
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();
    ajaxAddToCart(form, button);
  }, true);

  root.addEventListener('change', updateAddButtonPrice);
  document.addEventListener('variant:update', updateAddButtonPrice);
  document.addEventListener('variant:change', updateAddButtonPrice);
  document.addEventListener('cart:update', () => {
    if (drawer()?.classList.contains('is-open')) return;
    requestAnimationFrame(openCartDrawer);
  });
  window.addEventListener('load', updateAddButtonPrice);
  updateAddButtonPrice();
})();
